import { Component, DestroyRef, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NotificationItemComponent } from '../../../app/feature/notifications/components/notification-item/notification-item.component';
import { AuthService, ConfigStateService, LocalizationService } from '@abp/ng.core';
import { environment } from 'src/environments/environment';
import { ProfileService } from '@proxy/profiles';
import { AccountVerificationStatus } from '@proxy/account-verifications/enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [NotificationItemComponent, SharedModule, CommonModule, RouterModule],
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit  {
  isOpenMenu: boolean = false;
  status=AccountVerificationStatus
  @Output() openMenu: EventEmitter<any> = new EventEmitter();
  isShowSwitch: boolean = false;
  isSiteLangauageArabic = true;
  userVerificationInfo:any
  isAccountVerification:boolean
  loginToGuest() {
    // let url = 'https://hyyak.com/auth/login?lang='+this.localizationService.currentLang;
    let url = environment.guestUrl; //+ '/auth/login?lang='+this.localizationService.currentLang;
    window.location.href = url;
  }
  toggleMenu() {
    this.isOpenMenu = true;
    this.openMenu.emit(this.isOpenMenu);
  }
  currentUser: any;
  private readonly destroyRef = inject(DestroyRef);
  private authStateRefreshInFlight = false;
  constructor(
    private config: ConfigStateService,
    private profileService: ProfileService,
    private authService: AuthService,
    private localizationService: LocalizationService,
  ) {
  }

  ngOnInit(): void {
    this.isSiteLangauageArabic = this.localizationService.currentLang == 'ar';

    this.config
      .getOne$('currentUser')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(currentUser => {
        const isAuthenticated =
          !!currentUser?.isAuthenticated || this.authService.isAuthenticated;

        this.currentUser = currentUser?.isAuthenticated ? currentUser : this.currentUser;

        if (!isAuthenticated) {
          this.currentUser = null;
          this.userVerificationInfo = null;
          this.isAccountVerification = false;
          this.authStateRefreshInFlight = false;
          return;
        }

        if (!currentUser?.isAuthenticated) {
          this.refreshCurrentUserState();
          return;
        }

        this.profileService.getUserVerificationInfoDto().subscribe(data => {
          this.userVerificationInfo = data;
          this.isAccountVerification = this.userVerificationInfo?.status === this.status.Approved;
        });
      });
  }

  private refreshCurrentUserState(): void {
    if (this.authStateRefreshInFlight) {
      return;
    }

    this.authStateRefreshInFlight = true;
    this.config
      .refreshAppState()
      .pipe(
        catchError(() => {
          this.authStateRefreshInFlight = false;
          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.authStateRefreshInFlight = false;
      });
  }

  logOut() {
    this.authService.logout();
  }
}
